import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import NewAd from '@/views/NewAd.vue';
import VerifyAd from '@/views/VerifyAd.vue';
import Reply from '@/views/Reply.vue';
import Admin from '@/views/Admin.vue';
import Edit from '@/views/Edit.vue';
import AdComments from '@/components/User/AdComments.vue';
import ManageAd from '@/components/User/ManageAd.vue';
import DeleteAd from '@/components/User/DeleteAd.vue';
import Page404 from '@/views/Page404.vue';
import AdminAds from '@/components/Admin/AdminAds.vue';
import AdminComments from '@/components/Admin/AdminComments.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'NewAd',
    component: NewAd,
  },
  {
    path: '/verify/:externalId/auth/:auth',
    name: 'VerifyAd',
    component: VerifyAd,
  },
  {
    path: '/reply/:externalId',
    name: 'Reply',
    component: Reply,
  },
  {
    path: '/admin/:auth',
    name: 'Admin',
    component: Admin,
    props: ({params}) => ({...params}),
    children: [
      {
        path: 'manage',
        name: 'AdminAds',
        component: AdminAds,
        props: ({params}) => ({...params}),
      },
      {
        path: 'comments',
        name: 'AdminComments',
        component: AdminComments,
        props: ({params}) => ({...params}),
      },
    ],
  },
  {
    path: '/edit/:externalId/auth/:auth',
    name: 'Edit',
    component: Edit,
    props: ({params}) => ({...params}),
    children: [
      {
        path: 'manage',
        name: 'ManageAd',
        component: ManageAd,
        props: ({params}) => ({...params}),
      },
      {
        path: 'comments',
        name: 'AdComments',
        component: AdComments,
        props: ({params}) => ({...params}),
      },
      {
        path: 'delete',
        name: 'DeleteAd',
        component: DeleteAd,
        props: ({params}) => ({...params}),
      },
    ],
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/*',
    name: 'Page404',
    component: Page404,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
